import { useMemo, useState } from "react";
import { CreateInvoiceContext } from "./CreateInvoiceContext";
import type { CreateInvoiceContextValue, CreateInvoiceState, ServiceValues } from "./types";
import { useCreateInvoiceController } from "./hooks/useCreateController";

export function CreateInvoiceProvider({ children }: { children: React.ReactNode }) {
  const [serviceValues, setServiceValues] = useState<ServiceValues>({});

  const controller = useCreateInvoiceController(setServiceValues);

  const state = useMemo<CreateInvoiceState>(() => ({ serviceValues }), [serviceValues]);

  const value = useMemo<CreateInvoiceContextValue>(() => ({ state, controller }), [state, controller]);

  return <CreateInvoiceContext.Provider value={value}>{children}</CreateInvoiceContext.Provider>;
}
